import type { LatestCondition, TreeCondition } from '@api/types'
import { useI18n } from '@i18n/I18nProvider'
import { formatDate } from '@i18n/locale'

// Color de cada estado: SIEMPRE con texto al lado (nunca solo color, por accesibilidad).
export const CONDITION_STYLES: Record<TreeCondition, string> = {
	healthy: 'bg-healthy',
	dry: 'bg-dry',
	needs_pruning: 'bg-needs-pruning',
	damaged: 'bg-damaged',
}

export const ConditionBadge = ({ latest }: { latest: LatestCondition }) => {
	const { t, locale } = useI18n()
	if (!latest)
		return (
			<p className="inline-flex items-center gap-2 rounded-full bg-earth-100 px-4 py-2 text-earth-800">
				{t('condition.none')}
			</p>
		)
	return (
		<div>
			<p
				className={`inline-flex items-center gap-2 rounded-full px-4 py-2 font-semibold text-white ${CONDITION_STYLES[latest.condition]}`}
			>
				<span className="size-2.5 rounded-full bg-white/90" aria-hidden="true" />
				{t(`condition.${latest.condition}`)}
			</p>
			<p className="mt-1 text-sm text-earth-800">
				{t('condition.reportedOn', { date: formatDate(latest.reportedAt, locale) })}
			</p>
		</div>
	)
}
